module.exports = __webpack_public_path__ + "static/img/default_img_lowinternet.13ffbe60.png";